export class QPublishScalerPage {
  /**
   * Created by Steve D on 9/10/2017.
   */
  constructor() {
    this.fPageX = null;
    this.fPageY = null;
    this.fMargin = null;
    this.fContentX = null;
    this.fContentY = null;
    this.fShrinkFactor = null;
  }

  InitPage(sizeX, sizeY, margin, shrinkFactor) {
    this.fPageX = sizeX;
    this.fPageY = sizeY;
    this.fMargin = margin;
    this.fContentX = sizeX - this.fMargin.fLeft - this.fMargin.fRight;
    this.fContentY = sizeY - this.fMargin.fTop - this.fMargin.fBottom;
    this.fShrinkFactor = shrinkFactor;
  }
}
